<template lang="pug">
main(v-if="Show")
  parallax-inview
    animation-fade-in-up
      .page-top-image
        .image
          img(src="../assets/image05.jpg")
        .text
          h1.title Menu
            span.title-caption メニュー

  section.section-menu(v-for="(menuTag, index) in Menus")
    parallax-inview
      animation-fade-in-up
        h2.title {{menuTag.tag}}
        img(src="../assets/image15.jpg" v-if="index === 0")
        img(src="../assets/image12.jpg" v-if="index === 1")
        img(src="../assets/image16.jpg" v-if="index === 2")
        img(src="../assets/image03.jpg" v-if="index === 3")
        img(src="../assets/image18.jpg" v-if="index === 4")
        div.menu-info(v-for="(menu, index) in menuTag.items")
          .menu-head
            p.menu-title {{menu.title}}
            p.menu-price {{Price(menu.price)}}
          p.menu-description {{menu.description}}

</template>

<script>
import ParallaxInview from './parallax/ParallaxInview.vue'
import AnimationFadeInUp from './effect/animation/AnimationFadeInUp.vue'
import MenuDatas from '../datas/Menu.json'

export default {
  head: {
    title() {
      return {
        inner: 'Shampoo Selection',
        separator: '|',
        complement: 'シャンプーセレクション 蔵前美容室 | Menu',
      }
    },
    link: [
      { rel: 'preconnect', href: 'https://fonts.gstatic.com' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@200;300;400;500;600;700;900&display=swap' }
    ]
  },
  props: ['loadingEnd'],
  components: {
    ParallaxInview,
    AnimationFadeInUp
  },
  computed: {
    Show:{
      get: function() {
        return this.loadingEnd
      }
    }
  },
  data: function() {
    return {
      Menus: MenuDatas
    }
  },
  methods: {
    Price: function(price) {
      return '¥ ' + Number(price).toLocaleString()
    }
  }
}
</script>

<style lang="scss" scoped>
.section-menu {
  padding: 0 25px;
  text-align: left;
  margin-top: 40px;
  .title {
    padding-left: 16px;
    position: relative;
    &:before {
      content: '';
      width: 5px;
      height: 22px;
      background: #fff;
      position: absolute;
      left: 0;
      top: 28px;
    }
  }

  .menu-info {
    padding: 20px 0;
    border-bottom: 1px solid #ccc;
    .menu-head {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;
      > .menu-title {
        font-weight: bold;
        position: relative;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue